import React, { useEffect, useRef, useState } from 'react';
import Nav from '@/components/ui/tos/desktop/Nav';
import { ContentSection, menu, normalizeForAnchor } from '@/utils/tos';
import Content from './Content';

interface Props {
  data: {
    title: string;
    date: string;
    sections: ContentSection[];
  };
  sections: ContentSection[];
  page?: string;
}

export default function Desktop({ data, sections, page }: Props) {
  const [currentContent, setCurrentContent] = useState<string | null>(null);

  return (
    <div className="mt-8 hidden justify-center md:flex">
      <Nav menu={menu} page={page} />
      <div className="grid max-w-[960px] grid-cols-3">
        <div className="sticky top-10 self-start">
          <div className="px-1 py-4 text-neutral-400">
            <p>Last Updated: {data.date}</p>
          </div>
          {sections.map(item => {
            return (
              <div
                data-active={currentContent === item.title}
                className="cursor-pointer p-1 hover:text-azure-500 data-[active=true]:text-azure-500"
                key={item.title}>
                <a href={`#${normalizeForAnchor(item.title)}`}>{item.title}</a>
              </div>
            );
          })}
        </div>
        <Content
          data={data}
          setCurrentContent={setCurrentContent}
          page={page}
        />
      </div>
    </div>
  );
}
